export const couponTypes = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED',
  MktUniteFee: 'MktUniteFee',
  WarehouseFees: 'WarehouseFees',
}
